import { AnswerValue } from './answer.value';

export class AnswerValueDto {
    readonly optionId: string;
    readonly pathwayId: string;
    readonly courseId: string;
    readonly moduleId: string;

    constructor(data: AnswerValue) {
        this.optionId = data.optionId;
        this.pathwayId = data.pathwayId;
        this.courseId = data.courseId;
        this.moduleId = data.moduleId;
    }
}
